import { IQService, IIntervalService } from "angular";
import { ReportJobService } from "./data-services";
import { JobTracker, LocalStorageJobStore } from "./job-tracker.service";

const TRACK_JOBS_KEY = "apexTrackedReportJobs";
const TRACKING_INTERVAL_MS = 5000;

export class ReportJobTracker extends JobTracker {
    constructor(private $q: IQService, $interval: IIntervalService, private reportJobService: ReportJobService) {
        'ngInject';
        super($interval, new LocalStorageJobStore(TRACK_JOBS_KEY), TRACKING_INTERVAL_MS);
    }

    /**
     * Get the list of all jobs being tracked by the tracker currently.
     */
    retrieveTrackedJobs() {
        return this.$q.all(Array.from(this.jobIDs).map(id =>
            this.reportJobService.retrieveReportJob(id)
                .then(job => {
                    if (!job) {
                        // Job was expired, so remove it from the tracking list.
                        this.stopTrackingJob(id);
                    }
                    return job;
                })
        // Filter expired jobs out from the results.
        )).then(jobs => jobs.filter(job => !!job))
    }
}
